import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API()+'trasyRodzKal/';

export default {

    getProceduraKopiujGodziny(params){
        return axios({
            method: 'get',
            url: AppConfig.HOST_API()+'rodzKal/pKopiujTrasyRodzKal/'+params,
        });
    },

    getGodzinyWTrasie(id_tr) {
        return axios({
            method: 'get',
            url: URL + 'trasa/'+id_tr,
        });
    },

    getGodzinyWTrasieIKalendarzu(id_tr,id_rk) {
        return axios({
            method: 'get',
            url: URL + 'trasa/'+id_tr+'/'+id_rk,
        });
    },

    addGodzina(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editGodzina(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteGodzina(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/definicjeGodzinStartowychjDlaTrasy/DefinicjaGodzinyStartowejService.js